import { createSelector } from 'reselect';

import {
  hasReductionActivitiesSelectedSelector,
  hasReductionStatementAgreedSelector,
} from '/business/shared/state/selectors/application/basket_meta/getBasketMetaSelector';

export default createSelector(
  [hasReductionStatementAgreedSelector, hasReductionActivitiesSelectedSelector],
  (...results) => {
    return results.every((item) => item && item !== '');
  },
);
